import React from 'react'
import { Field } from 'react-final-form'
import PropTypes from 'prop-types';
import localization from '../helpers/localization.js';


const InputWithLabel = (props) => {
    if (props.type != "file") {
        if (props.type === "checkbox") {
            return CheckboxField(props);
        }
        return (
            <Field name={props.name} type={props.type} validate={(value) => props.validator ? props.validator.validate(value) : ""} >
                {({ input, meta }) => (
                    <div className="inputWithLabel">
                        <label htmlFor={props.name} className="textinputLabel">{props.label} </label>
                        <div className={props.unit ? "inputUnitWrapper" : ""}>
                            <input {...input} id={props.name} type={props.type} autoComplete={props.autoComplete} inputMode={props.type === "number" ? "numeric" : undefined} placeholder={props.placeHolder} />
                            {props.unit && <span className="inputUnit">{props.unit}</span>}
                        </div>
                        <InfoLink infoLink={props.infoLink} />
                        {meta.error && meta.touched && <span className="errors">{meta.error}</span>}
                    </div>
                )}
            </Field>
        );
    }
    else
        return FileField(props);
}

const CheckboxField = (props) => (
    <Field name={props.name} type="checkbox" validate={(value) => props.validator ? props.validator.validate(value) : ""}>
        {({ input, meta }) => (
            <div className="inputWithLabel checkboxInput">
                <label htmlFor={props.name} className="checkboxInputLabel">
                    <input {...input} id={props.name} type="checkbox" />
                    <span>{props.label}</span>
                </label>
                {meta.error && meta.touched && <span className="errors">{meta.error}</span>}
                <InfoLink infoLink={props.infoLink} />
            </div>
        )}
    </Field>
)

const FileField = (props) => {
    return (<Field type="FileList" name={props.name}>
        {({ input: { value, onChange, ...input }, meta }) => (
            <div className="inputWithLabel">
                <label htmlFor={props.name} className="textinputLabel">{props.label} </label>
                <input
                    {...input}
                    id={props.name}
                    type="file"
                    onChange={({ target }) => onChange(Array.from(target.files))}
                    {...props}
                />
                {meta.error && meta.touched && <span className="errors">{meta.error}</span>}
            </div>
            )}
        </Field>)
        }
export default InputWithLabel

InputWithLabel.propTypes = {
    name: PropTypes.string.isRequired
};

let InfoLink = ({ infoLink }) => {
    if (infoLink) {
        return (<span className="privacyStatementLink"><a href={infoLink} target="_blank" rel="noopener noreferrer">{localization.privacyStatement}</a></span>);
    }
    else {
        return null;
    }
}
